export const firebaseConfig = {
  apiKey: "AIzaSyDSHWyz_5o2gz5Zrq4lds2jQSsnewwsgug",
  authDomain: "iwdbrasil2021.firebaseapp.com",
  databaseURL: "https://iwdbrasil2021-default-rtdb.firebaseio.com",
  projectId: "iwdbrasil2021",
  storageBucket: "iwdbrasil2021.appspot.com",
  messagingSenderId: "292197594369",
  appId: "1:292197594369:web:d9f482bc1779020b565700",
  // Firebase node which your data will be stored (ex. 2017)
  devfestYear: '2022',
  // Your Google Maps API key
  mapsKey: '<MAPS_API_KEY>'
};
